import React from 'react';
import { Info } from 'lucide-react';

function InfoTooltip({ text }) {
  return (
    <span className="info-tooltip-wrapper">
      <Info size={13} className="info-tooltip-icon" />
      <span className="info-tooltip-bubble">{text}</span>
    </span>
  );
}

export default InfoTooltip;
